// Small display helpers shared by the program-news ops panels.

export function formatDateTime(at: string | null | undefined): string {
  if (!at) return "—";
  const date = new Date(at);
  return Number.isNaN(date.getTime()) ? at : date.toLocaleString();
}

export function formatDate(at: string | null | undefined): string {
  if (!at) return "—";
  const date = new Date(at);
  return Number.isNaN(date.getTime()) ? at : date.toLocaleDateString();
}

/** 42000 → "42s", 125000 → "2m 5s". */
export function formatDuration(ms: number | null | undefined): string {
  if (typeof ms !== "number" || !Number.isFinite(ms) || ms < 0) return "—";
  const totalSeconds = Math.round(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const minutes = Math.floor(totalSeconds / 60);
  return `${minutes}m ${totalSeconds % 60}s`;
}

export function formatUsd(value: number | null | undefined): string {
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";
  return `$${value.toFixed(2)}`;
}

/** 0.92 → "92%". Accepts values already in percent (92 → "92%"). */
export function formatConfidence(value: number | null | undefined): string {
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";
  const percent = value <= 1 ? value * 100 : value;
  return `${Math.round(percent)}%`;
}
